import React, { Component } from 'react';
import { connect } from 'react-redux';
import { notification } from 'antd';
import { isMobile } from "react-device-detect";
import DesktopSectionHeader from './desktop/sectionHeader';
import MobileSectionHeader from './mobile/m-sectionHeader';
import InviteViaTexModal from '../../components/inviteTextModal/invite-via-textModal';
import ScheduledSupersionModal from '../../components/scheduled-supervision-modal/scheduled-supervision-modal';
import { baseChatURL } from '../../constants/global';

class SectionHeader extends Component {
	constructor(props) {
		super(props);
		this.state={
			isDropdown:false,
			showInviteModal:false,
			showSupervisionModal:false
		}
		this.openInviteModal=this.openInviteModal.bind(this);
		this.closeInviteModal=this.closeInviteModal.bind(this);
		this.copyToClipBoard=this.copyToClipBoard.bind(this);
		this.openEmailLink=this.openEmailLink.bind(this);
	}


	  openInviteModal(){
        this.setState({
            showInviteModal:true
        });   
    	}

		closeInviteModal(){
        this.setState({
            showInviteModal:false
        });   
	}
	
	copyToClipBoard =  () => {
		const { therapistRoom } = this.props;
        let textField = document.createElement('textarea')
        textField.innerText = (baseChatURL+"/videoroom/"+therapistRoom);
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        notification['success']({
			message: 'Success',
			description: 'Link has been copied!',
		});
	}
	
	openEmailLink(){
		const { setting, therapistRoom } = this.props;
		const { currentUser } = setting;
		const context = encodeURI("Hello, this is " + (currentUser.firstName + " " + currentUser.lastName) + ". Please join me for a secure video call at:\n" + (baseChatURL+"/videoroom/"+therapistRoom));
		window.location.href = "mailto:?subject=Video%20Room%20Link&body="+context;
	}

	closeSupervisionModal = () =>{
		this.setState({
			showSupervisionModal: false
		});
	}

	render() {
		if(isMobile){
			return [<MobileSectionHeader key="1" {...this.props} {...this.state}
										openEmailLink={this.openEmailLink}
										closeInviteModal={this.closeInviteModal}
										handleClick={this.handleClick}
										handleOutsideClick={this.handleOutsideClick}
										copyToClipBoard={this.copyToClipBoard}
										openInviteModal={this.openInviteModal} />,
										<InviteViaTexModal key="2" therapistRoom={this.props.therapistRoom} visible={this.state.showInviteModal} 
										onCancel={this.closeInviteModal}  />,
										<ScheduledSupersionModal visible={this.state.showSupervisionModal}
											onCancel={this.closeSupervisionModal} dismissSupervisionModal={this.closeSupervisionModal} />
										]
		}else{
			return [<DesktopSectionHeader key="1" {...this.props} {...this.state}
									openEmailLink={this.openEmailLink}
									closeInviteModal={this.closeInviteModal}
									handleClick={this.handleClick}
									handleOutsideClick={this.handleOutsideClick}
									copyToClipBoard={this.copyToClipBoard}
									openInviteModal={this.openInviteModal} />,
									<InviteViaTexModal key="2" therapistRoom={this.props.therapistRoom} visible={this.state.showInviteModal} 
									onCancel={this.closeInviteModal}  />,
									<ScheduledSupersionModal visible={this.state.showSupervisionModal}
										onCancel={this.closeSupervisionModal} dismissSupervisionModal={this.closeSupervisionModal} />
									]
		}
	}
}

export default connect(
	state => state
)(SectionHeader);
